var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 21.4H16.9V19.6H15.1V21.4ZM16 7C11.032 7 7 11.032 7 16C7 20.968 11.032 25 16 25C20.968 25 25 20.968 25 16C25 11.032 20.968 7 16 7ZM16 23.2C12.031 23.2 8.8 19.969 8.8 16C8.8 12.031 12.031 8.8 16 8.8C19.969 8.8 23.2 12.031 23.2 16C23.2 19.969 19.969 23.2 16 23.2ZM16 10.6C14.011 10.6 12.4 12.211 12.4 14.2H14.2C14.2 13.21 15.01 12.4 16 12.4C16.99 12.4 17.8 13.21 17.8 14.2C17.8 16 15.1 15.775 15.1 18.7H16.9C16.9 16.675 19.6 16.45 19.6 14.2C19.6 12.211 17.989 10.6 16 10.6Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHelp);
export default __webpack_public_path__ + "static/media/ic_help.194c08b873775c932dd4f882852e1654.svg";
export { ForwardRef as ReactComponent };